import { apiClient } from '../apiClient';

/**
 * Default shared Axios instance — identical to `apiClient` (JWT, timeouts, 401 handling).
 * Prefer `import { apiClient } from '../apiClient'` in new code; this file exists for
 * existing `import api from './api'` / `import api from '.../services/api/api'` call sites.
 */
export default apiClient;
